import React, { memo, useMemo, useState } from 'react';
import * as styles from './LinkCardV1.module.scss';
import { GatsbyImage } from 'gatsby-plugin-image';
import RedNumberText from '../../RedNumberText/RedNumberText';
import useInAppBrowser from '../../../hooks/useInAppBrowser';
import {
  DISCLAIMER_PLATFORMS,
  PLATFORM_BG_COLOR_MAP,
} from '../../../constants';
import LinkDisclaimer from '../../LinkDisclaimer/LinkDisclaimer';
import { PLATFORM_ICON_MAP } from '../../V2/icons';

const LinkCardV1 = ({ platform, platformTitle, url, icon }) => {
  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);

  const platformIcon = useMemo(
    () =>
      platform ? (
        PLATFORM_ICON_MAP[platform]()
      ) : (
        <GatsbyImage
          image={icon}
          alt="Background image"
          className={styles.customLinkIcon}
        />
      ),
    [platform, icon]
  );

  const shouldShowDisclaimer = useMemo(
    () => DISCLAIMER_PLATFORMS.includes(platform?.toLowerCase()),
    [platform]
  );

  const { handleLinkClick } = useInAppBrowser({ url });

  const Link = ({ children }) => (
    <a href={url} target="_blank" rel="noreferrer" onClick={handleLinkClick}>
      {children}
    </a>
  );

  const CardWrapper = ({ children }) =>
    shouldShowDisclaimer ? (
      <button
        className={styles.linkButton}
        onClick={() => setIsDisclaimerVisible(true)}
      >
        {children}
      </button>
    ) : (
      <Link>{children}</Link>
    );

  return (
    <CardWrapper>
      <div
        className={styles.linkCard}
        style={{ backgroundColor: PLATFORM_BG_COLOR_MAP[platform] }}
      >
        {isDisclaimerVisible && <LinkDisclaimer url={url} />}

        {!isDisclaimerVisible && (
          <>
            <div className={styles.linkCardIcon}>{platformIcon}</div>

            <p className={styles.linkCardTitle}>
              <RedNumberText {...platformTitle} />
            </p>
          </>
        )}
      </div>
    </CardWrapper>
  );
};

export default memo(LinkCardV1);
